class GMap {
    constructor(el) {
        this.el = el;
        this.data = window[el.data('markers')];
        this.gapikey = window._amc_gapikey;

        this.init();
    }

    loadGapi() {
        let gapi
        let gapiPromise = new Promise((resolve) => {
            window['amc_onGapiLoaded'] = () => resolve();
            const gapiNode = document.createElement('script');

            gapiNode.src = 'https://maps.googleapis.com/maps/api/js?key=' + this.gapikey + '&callback=amc_onGapiLoaded';
            gapiNode.type = 'text/javascript';

            document.getElementsByTagName('head')[0].appendChild(gapiNode);
        });

        return gapiPromise;
    }

    drawMarkers() {
        let self = this;
        this.data.forEach(markerData => {
            console.log(markerData);
            // const icon = {
            //     url: '/wp-content/themes/scolaris/img/ico-marker.svg',
            //     size: new google.maps.Size(26, 34)
            // };
            let position = new google.maps.LatLng(markerData.lat, markerData.lng);
            let marker = new google.maps.Marker({
                position: position,
                map: this.map,
                // icon: icon
            });
            this.mapBounds.extend(position);

            if (markerData.clickable) {
                marker.addListener('click', function() {
                    self.infowindow.setContent(markerData.content);
                    self.infowindow.open(self.map, marker);
                });

            }
        });

        if (this.data.length > 1) {
            this.map.fitBounds(this.mapBounds);

            let ww = window.innerWidth;
            if (ww > 1200 && ww < 1400) {
                this.map.panBy(0, -80);
            }
            if (ww >= 1400) {
                this.map.panBy(0, -100);
            }
        }
    }

    initMap() {
        let mapProp = {
            center: new google.maps.LatLng(this.data[0].lat, this.data[0].lng),
            zoom: 15,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            scrollwheel: false,
            styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#545454"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#e2e2e2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":'#0090a8'},{"visibility":"on"}]}]
        };

        this.map = new google.maps.Map(this.el.get(0), mapProp);
        this.mapBounds = new google.maps.LatLngBounds();
        this.infowindow = new google.maps.InfoWindow();

        this.drawMarkers();
    }

    init() {
        if (typeof window['google'] == 'object' && google.maps) {
            this.initMap();
        } else {
            this.loadGapi().then(() => this.initMap());
        }
    }
}